import axiosInstance from "../service/axios";
import { Claim, ChatMessage } from "@/types";

class ChatService {
  async fetchPolicies() {
    const response = await axiosInstance.get("api/customer/getPolicies");
    return response.data.data;
  }

  async fetchClaims() {
    const response = await axiosInstance.get("api/customer/getClaims");
    return response.data.data;
  }

  async createClaim(minimal: { policyId: string }): Promise<Claim> {
    const payload = {
      policy_id: minimal.policyId,
    };

    const response = await axiosInstance.post(
      "api/customer/createClaim",
      payload,
    );
    return response.data.data as Claim;
  }

  async openClaim(args: { policyId: string; claimId?: string }): Promise<any> {
    const response = await axiosInstance.post("api/customer/openClaim", {
      policy_id: args.policyId,
      ...(args.claimId ? { claim_id: args.claimId } : {}),
    });
    return response.data.data ?? response.data;
  }

  async checkForCare(minimal: { policyId: string }) {
    const payload = {
      policy_id: minimal.policyId,
    };

    const response = await axiosInstance.post(
      "api/customer/checkForCareTrue",
      payload,
    );
    return response.data.data
  }

  async sendMessage(
    message: ChatMessage,
    claimId: string,
    currentChatToGpt: ChatMessage[],
  ) {
    const response = await axiosInstance.post("api/triage/chat", {
      claim_id: claimId,
      messagesArr: [...currentChatToGpt, message],
    });
    console.log(response.data);
    return response.data;
  }

  async uploadEvidence(formData: FormData) {
    const response = await axiosInstance.post(
      "api/customer/claim/uploadEvidence",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  }

  async submitClaim(claimId: string) {
    const response = await axiosInstance.post("api/triage/evaluate", {
      claim_id: claimId,
    });
    return response.data;
  }
}

export const chatService = new ChatService();
